/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  loading: false,
  work_packages: [],
  pagination: {},
  new_custom_work_package: {
    id: -1,
    name: "",
    token: "",
    icon: "obj-drainage-pipe",
    description: "",
    color: "red",
    textcolor: "black",
    quantity_unit: "",
    quantity_value: 0,
    contact_name: "",
    contact_email: "",
    contact_phone_number: "",
    manpower_planned: 0,
    country: {
      name: 'Germany',
      flag: 'de'
    },
    work_steps: [],
    quality_steps: [],
    defect_steps: [],
    handover_steps: [],
    design_steps: [],
    logistic_steps: [],
    hashtags: []
  },
  average_ai: {
    time_effort_planned: 1,
    manpower_planned: 20,
    quantity_value: 10,
    work_steps_count: 3,
    defect_steps_count: 1,
    quality_steps_count: 4,
    logistic_steps_count: 1,
    design_steps_count: 2,
  },
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getWorkPackages: ( state ) => {
    return state.work_packages;
  },
  getWorkPackage: (state) => (id) => {
    return state.work_packages.find(work_package => work_package.id === id);
  },
  getPagination: (state) => state.pagination,
  getWorkPackagesFiltered: ( state ) => (search) => {
    if (search !== '') {
      return state.work_packages.filter(work_package =>
        work_package.token.toLowerCase().includes(search.toLowerCase()) ||
        work_package.name.toLowerCase().includes(search.toLowerCase()));
    } else {
      return state.work_packages;
    }
  },
  getNewCustomWorkPackage: ( state ) => {
    return state.new_custom_work_package;
  },
  getAverageAi: (state) => {
    return state.average_ai;
  },
  isLoading: ( state ) => {
    return state.loading;
  },
  getNewIcon: (state, getters, rootState) => (icon) => {
    let new_icon = rootState.Ultra.icons_old_new.find(e => e.old === icon);
    if (new_icon === undefined) {
      return icon;
    } else {
      return new_icon.new;
    }
  },
  getWorkPackageIcons: (state, getters, rootState) => {
    let icons = [];
    rootState.Ultra.icons.forEach((item) => {
      icons.push(item.id);
    });
    return icons;
  }
};
// Actions
const actions = {
  changeTWorkPackage({commit, dispatch, rootState}, payload) {
    return new Promise(resolve => {
      if (payload.snackbar_call) {
        let ids = [payload.tworkpackage_id];
        axios({
          url: 'projects/' + payload.project_id + '/snackbar',
          method: 'POST',
          data: {
            target_entity: 'tworkpackages',
            id: payload.tworkpackage_id,
            wp_part: false
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        }).then(resp => {
          ids = ids.concat(resp.data.data.targets.ids);
          let updates = [];
          ids.forEach(() => {
            updates.push(payload.new_wp);
          });
          axios({
            url: 'projects/' + payload.project_id +
            '/trains/' + payload.train_id +
            '/taktareas/' + payload.taktarea_id +
            '/twaggons/' + payload.twaggon_id +
            '/tworkpackages/' + '0' +
            '/updatebulk',
            method: 'PUT',
            data: {
              tworkpackages: ids,
              updates: updates
            },
            headers: {
              'Cache-Control': 'no-cache'
            }
          }).then(() => {
            payload.ids = ids;
            commit('change_tworkpackage', {rootState, payload});
            resolve();
          });
        });
      } else {
        dispatch('Ultra/updateUObject', {
          url: [
            {projects: payload.project_id},
            {trains: payload.train_id},
            {taktareas: payload.taktarea_id},
            {twaggons: payload.twaggon_id},
            {tworkpackages: payload.tworkpackage_id}
          ],
          update: payload.new_wp
        }, {root: true});
        resolve();
      }
    });
  },
  createCompleteWorkPackage({commit, getters}){
    // commit('set_loading', true);
    return new Promise((resolve, reject) => {
      let stateWorkPackage = getters.getNewCustomWorkPackage;
      let work_package = {
        work_steps: [],
        quality_steps: [],
        defect_steps: [],
        handover_steps: [],
        design_steps: [],
        logistic_steps: [],
      };
      work_package.country = stateWorkPackage.country.flag;
      work_package.hashtags = stateWorkPackage.hashtags;

      work_package.name = stateWorkPackage.name;
      work_package.token = stateWorkPackage.token;
      work_package.icon = stateWorkPackage.icon;
      work_package.description = stateWorkPackage.description;
      work_package.color = stateWorkPackage.color;
      work_package.textcolor = stateWorkPackage.textcolor;
      // work_package.workload = stateWorkPackage.workload;
      work_package.manpower_planned = parseInt(stateWorkPackage.manpower_planned);
      // work_package.time_effort_planned = stateWorkPackage.time_effort_planned;
      // work_package.quantity_value = stateWorkPackage.quantity_value;
      work_package.quantity_unit = stateWorkPackage.quantity_unit;
      for (let i = 0; i < stateWorkPackage.work_steps.length; i++) {
        let work_step = {};
        work_step.text = stateWorkPackage.work_steps[i].text;
        work_step.manpower_planned = parseInt(stateWorkPackage.work_steps[i].manpower_planned);
        work_package.work_steps.push(work_step);
      }
      for (let j = 0; j < stateWorkPackage.quality_steps.length; j++) {
        let quality_step = {};
        quality_step.text = stateWorkPackage.quality_steps[j].text;
        quality_step.offset = parseInt(stateWorkPackage.quality_steps[j].offset);
        work_package.quality_steps.push(quality_step);
      }
      for (let k = 0; k < stateWorkPackage.defect_steps.length; k++) {
        let defect_step = {};
        defect_step.text = stateWorkPackage.defect_steps[k].text;
        defect_step.offset = parseInt(stateWorkPackage.defect_steps[k].offset);
        work_package.defect_steps.push(defect_step);
      }
      for (let k = 0; k < stateWorkPackage.handover_steps.length; k++) {
        let handover_step = {};
        handover_step.text = stateWorkPackage.handover_steps[k].text;
        handover_step.offset = parseInt(stateWorkPackage.handover_steps[k].offset);
        work_package.handover_steps.push(handover_step);
      }
      for (let k = 0; k < stateWorkPackage.design_steps.length; k++) {
        let design_step = {};
        design_step.text = stateWorkPackage.design_steps[k].text;
        design_step.offset = parseInt(stateWorkPackage.design_steps[k].offset);
        work_package.design_steps.push(design_step);
      }
      for (let k = 0; k < stateWorkPackage.logistic_steps.length; k++) {
        let logistic_step = {};
        logistic_step.text = stateWorkPackage.logistic_steps[k].text;
        logistic_step.offset = parseInt(stateWorkPackage.logistic_steps[k].offset);
        work_package.logistic_steps.push(logistic_step);
      }

      axios({
        url: 'workpackages/completeworkpackage',
        method: 'POST',
        data: work_package
      })
      .then(resp => {
        commit('add_work_package', resp.data.data);
        commit('reset_work_package_editor');
        // commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        // commit('set_loading', false);
        reject();
      });
    });
  },
  requestCustomWorkPackages({ commit }, page){
    // commit('set_loading', true);
    return new Promise((resolve, reject)=> {
      let offset = (page - 1 || 0) * 15;
      axios({
          url: 'workpackages?show=showForCustoms&offset=' + offset + '&limit=50',
          method: 'GET',
          headers: {'Cache-Control': 'no-cache'}
        })
        .then(resp => {
          commit('set_work_packages', resp.data.data);
          commit('set_work_packages_pagination', resp.data.meta_data);
          // commit('set_loading', false);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  suggestToCommunity({commit}, work_package_id){
    axios({
      url: 'workpackages/' + work_package_id,
      method: 'PUT',
      data: {
        is_community_suggested: true
      }
    })
    .then(() => {
      commit('update_community_suggested', work_package_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteWorkPackage({commit}, work_package_id){
    axios({
      url: 'workpackages/' + work_package_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('delete_work_package', work_package_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkPackage({commit}, payload){
    axios({
      url: 'workpackages/' + payload.work_package_id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_work_package', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkPackageHashtags({commit}, payload){
    axios({
      url: 'workpackages/' + payload.work_package_id + '/hashtags',
      method: 'PUT',
      data: payload.update
    })
    .then(resp => {
      commit('replace_work_package', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkPackageWWorkStep({commit}, payload){
    axios({
      url: 'workpackages/' +
            payload.work_package_id +
            '/wworksteps/' +
            payload.wwork_step_id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_wwork_step', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkPackageWWorkStepPushPosition({commit}, payload){
    axios({
      url: 'workpackages/' +
            payload.work_package_id +
            '/wworksteps/' +
            payload.wwork_step_id +
            '/pushpositions',
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_wwork_step_push_position', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  setNewCustomWorkPackageName({commit}, payload){
    commit('set_new_custom_work_package_name', payload);
    commit('add_new_custom_work_package_hashtags', payload.replace(/ /g, ''));
  },
  setNewCustomWorkPackageToken({commit}, payload){
    commit('set_new_custom_work_package_token', payload);
    commit('add_new_custom_work_package_hashtags', payload);
  },
  setNewCustomWorkPackageDescription({commit}, payload){
    commit('set_new_custom_work_package_description', payload);
    commit('add_new_custom_work_package_hashtags', payload.replace(/ /g, ''));
  },
  setNewCustomWorkPackageIcon({commit}, payload){
    commit('set_new_custom_work_package_icon', payload);
  },
  setNewCustomWorkPackageColor({commit}, payload){
    commit('set_new_custom_work_package_color', payload);
  },
  setNewCustomWorkPackageTextColor({commit}, payload){
    commit('set_new_custom_work_package_textcolor', payload);
  },
  setNewCustomWorkPackageManpower({commit}, payload){
    commit('set_new_custom_work_package_manpower', payload);
  },
  setNewCustomWorkPackageWorkload({commit}, payload){
    commit('set_new_custom_work_package_workload', payload);
  },
  setNewCustomWorkPackageQuantityUnit({commit}, payload){
    commit('set_new_custom_work_package_quantity_unit', payload);
  },
  setNewCustomWorkPackageQuantityValue({commit}, payload){
    commit('set_new_custom_work_package_quantity_value', payload);
  },
  setNewCustomWorkPackageCountry({commit}, payload){
    commit('set_new_custom_work_package_country', payload);
  },
  setNewCustomWorkPackageContactName({commit}, payload){
    commit('set_new_custom_work_package_contact_name', payload);
  },
  setNewCustomWorkPackageContactEmail({commit}, payload){
    commit('set_new_custom_work_package_contact_email', payload);
  },
  setNewCustomWorkPackageContactPhoneNumber({commit}, payload){
    commit('set_new_custom_work_package_contact_phone_number', payload);
  },
  setNewCustomWorkPackageHashtags( {commit}, payload){
    commit('set_new_custom_work_package_hashtags', payload);
  },
  pushNewCustomWWorkStep( {commit}, payload){
    commit('push_new_custom_wwork_step', payload);
  },
  pushNewCustomQualityStep( {commit}, payload){
    commit('push_new_custom_quality_step', payload);
  },
  pushNewCustomDefectStep( {commit}, payload){
    commit('push_new_custom_defect_step', payload);
  },
  pushNewCustomHandoverStep( {commit}, payload){
    commit('push_new_custom_handover_step', payload);
  },
  pushNewCustomDesignStep( {commit}, payload){
    commit('push_new_custom_design_step', payload);
  },
  pushNewCustomLogistcStep( {commit}, payload){
    commit('push_new_custom_logistic_step', payload);
  },
  sliceNewCustomWWorkStep( {commit}, payload){
    commit('slice_new_custom_wwork_step', payload);
  },
  setNewCustomWWorkSteps( {commit}, payload){
    commit('set_new_custom_wwork_steps', payload);
  },
  sliceNewCustomQualityStep( {commit}, payload){
    commit('slice_new_custom_quality_step', payload);
  },
  setNewCustomQualitySteps( {commit}, payload){
    commit('set_new_custom_quality_steps', payload);
  },
  setQualityStepOffset( {commit}, payload){
    commit('set_quality_step_offset', payload);
  },
  sliceNewCustomDefectStep( {commit}, payload){
    commit('slice_new_custom_defect_step', payload);
  },
  setNewCustomDefectSteps( {commit}, payload){
    commit('set_new_custom_defect_steps', payload);
  },
  setDefectStepOffset( {commit}, payload){
    commit('set_defect_step_offset', payload);
  },
  sliceNewCustomHandoverStep( {commit}, payload){
    commit('slice_new_custom_handover_step', payload);
  },
  setNewCustomHandoverSteps( {commit}, payload){
    commit('set_new_custom_handover_steps', payload);
  },
  setHandoverStepOffset( {commit}, payload){
    commit('set_handover_step_offset', payload);
  },
  sliceNewCustomDesignStep( {commit}, payload){
    commit('slice_new_custom_design_step', payload);
  },
  setNewCustomDesignSteps( {commit}, payload){
    commit('set_new_custom_design_steps', payload);
  },
  setDesignStepOffset( {commit}, payload){
    commit('set_design_step_offset', payload);
  },
  sliceNewCustomLogisticStep( {commit}, payload){
    commit('slice_new_custom_logistic_step', payload);
  },
  setNewCustomLogisticSteps( {commit}, payload){
    commit('set_new_custom_logistic_steps', payload);
  },
  setLogisticStepOffset( {commit}, payload){
    commit('set_logistic_step_offset', payload);
  },
  resetWorkPackageEdior({commit}){
    commit('reset_work_package_editor');
  }
};
// Mutations
const mutations = {
  change_tworkpackage(state, {rootState, payload}) {
    payload.ids.forEach(id => {
      let wp = rootState.Ultra.tworkpackages[id];
      Object.assign(wp, payload.new_wp);
    });
  },
  add_work_package(state, work_package) {
    state.work_packages = [...state.work_packages, work_package];
  },
  replace_work_package(state, work_package){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == work_package.id;
    });
    state.work_packages = [
      ...state.work_packages.slice(0, index),
      work_package,
      ...state.work_packages.slice(index + 1)
    ];
  },
  reset_work_package_editor(state){
    state.new_custom_work_package = {
      id: -1,
      name: "",
      token: "",
      icon: "obj-drainage-pipe",
      description: "",
      color: "red",
      textcolor: "black",
      quantity_unit: "",
      quantity_value: 0,
      contact_name: "",
      contact_email: "",
      contact_phone_number: "",
      manpower_planned: 0,
      country: {
        name: 'Germany',
        flag: 'de'
      },
      work_steps: [],
      quality_steps: [],
      defect_steps: [],
      handover_steps: [],
      design_steps: [],
      logistic_steps: [],
      hashtags: []
    };
  },
  log_lists_error(state, err) {
    state.error = err;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_error(state, error) {
    state.error = error;
  },
  set_new_custom_work_package_name(state, name){
    state.new_custom_work_package.name = name;
  },
  set_new_custom_work_package_token(state, token){
    state.new_custom_work_package.token = token;
  },
  set_new_custom_work_package_description(state, description){
    state.new_custom_work_package.description = description;
  },
  set_new_custom_work_package_icon(state, icon){
    state.new_custom_work_package.icon = icon;
  },
  set_new_custom_work_package_color(state, color){
    state.new_custom_work_package.color = color;
  },
  set_new_custom_work_package_textcolor(state, textcolor){
    state.new_custom_work_package.textcolor = textcolor;
  },
  set_new_custom_work_package_manpower(state, manpower_planned){
    state.new_custom_work_package.manpower_planned = manpower_planned;
  },
  set_new_custom_work_package_workload(state, workload){
    state.new_custom_work_package.workload = workload;
  },
  set_new_custom_work_package_quantity_unit(state, quantity_unit){
    state.new_custom_work_package.quantity_unit = quantity_unit;
  },
  set_new_custom_work_package_quantity_value(state, quantity_value){
    state.new_custom_work_package.quantity_value = quantity_value;
  },
  set_new_custom_work_package_contact_name(state, contact_name){
    state.new_custom_work_package.contact_name = contact_name;
  },
  set_new_custom_work_package_contact_email(state, contact_email){
    state.new_custom_work_package.contact_email = contact_email;
  },
  set_new_custom_work_package_contact_phone_number(state, contact_phone_number){
    state.new_custom_work_package.contact_phone_number = contact_phone_number;
  },
  set_new_custom_work_package_country(state, country){
    state.new_custom_work_package.country = country;
  },
  set_new_custom_work_package_hashtags(state, hashtags){
    state.new_custom_work_package.hashtags = [...hashtags];
  },
  add_new_custom_work_package_hashtags(state, hashtag){
    state.new_custom_work_package.hashtags.push(hashtag);
  },
  push_new_custom_wwork_step(state, text){
    state.new_custom_work_package.work_steps = [
      ...state.new_custom_work_package.work_steps,
      {text: text.trim(), manpower_planned: 0}
    ];
  },
  push_new_custom_quality_step(state, text){
    state.new_custom_work_package.quality_steps = [
      ...state.new_custom_work_package.quality_steps,
      {text: text.trim(), offset: 0}
    ];
  },
  push_new_custom_defect_step(state, text){
    state.new_custom_work_package.defect_steps = [
      ...state.new_custom_work_package.defect_steps,
      {text: text.trim(), offset: 0}
    ];
  },
  push_new_custom_handover_step(state, text){
    state.new_custom_work_package.handover_steps = [
      ...state.new_custom_work_package.handover_steps,
      {text: text.trim(), offset: 0}
    ];
  },
  push_new_custom_design_step(state, text){
    state.new_custom_work_package.design_steps = [
      ...state.new_custom_work_package.design_steps,
      {text: text.trim(), offset: 0}
    ];
  },
  push_new_custom_logistic_step(state, text){
    state.new_custom_work_package.logistic_steps = [
      ...state.new_custom_work_package.logistic_steps,
      {text: text.trim(), offset: 0}
    ];
  },
  slice_new_custom_wwork_step(state, index){
    state.new_custom_work_package.work_steps = [
      ...state.new_custom_work_package.work_steps.slice(0, index),
      ...state.new_custom_work_package.work_steps.slice(index + 1)
    ];
  },
  set_new_custom_wwork_steps(state, payload){
    state.new_custom_work_package.work_steps = [...payload];
  },
  slice_new_custom_quality_step(state, index){
    state.new_custom_work_package.quality_steps = [
      ...state.new_custom_work_package.quality_steps.slice(0, index),
      ...state.new_custom_work_package.quality_steps.slice(index + 1)
    ];
  },
  set_new_custom_quality_steps(state, payload){
    state.new_custom_work_package.quality_steps = [...payload];
  },
  slice_new_custom_defect_step(state, index){
    state.new_custom_work_package.defect_steps = [
      ...state.new_custom_work_package.defect_steps.slice(0, index),
      ...state.new_custom_work_package.defect_steps.slice(index + 1)
    ];
  },
  set_new_custom_defect_steps(state, payload){
    state.new_custom_work_package.defect_steps = [...payload];
  },
  slice_new_custom_handover_step(state, index){
    state.new_custom_work_package.handover_steps = [
      ...state.new_custom_work_package.handover_steps.slice(0, index),
      ...state.new_custom_work_package.handover_steps.slice(index + 1)
    ];
  },
  set_new_custom_handover_steps(state, payload){
    state.new_custom_work_package.handover_steps = [...payload];
  },
  slice_new_custom_design_step(state, index){
    state.new_custom_work_package.design_steps = [
      ...state.new_custom_work_package.design_steps.slice(0, index),
      ...state.new_custom_work_package.design_steps.slice(index + 1)
    ];
  },
  set_new_custom_design_steps(state, payload){
    state.new_custom_work_package.design_steps = [...payload];
  },
  slice_new_custom_logistic_step(state, index){
    state.new_custom_work_package.logistic_steps = [
      ...state.new_custom_work_package.logistic_steps.slice(0, index),
      ...state.new_custom_work_package.logistic_steps.slice(index + 1)
    ];
  },
  set_new_custom_logistic_steps(state, payload){
    state.new_custom_work_package.logistic_steps = [...payload];
  },
  set_quality_step_offset(state, payload) {
    let quality_step = state.new_custom_work_package.quality_steps[payload.index];
    quality_step.offset = payload.offset;
    state.new_custom_work_package.quality_steps = [
      ...state.new_custom_work_package.quality_steps.slice(0, payload.index),
      quality_step,
      ...state.new_custom_work_package.quality_steps.slice(payload.index + 1)
    ];
  },
  set_defect_step_offset(state, payload) {
    let defect_step = state.new_custom_work_package.defect_steps[payload.index];
    defect_step.offset = payload.offset;
    state.new_custom_work_package.defect_steps = [
      ...state.new_custom_work_package.defect_steps.slice(0, payload.index),
      defect_step,
      ...state.new_custom_work_package.defect_steps.slice(payload.index + 1)
    ];
  },
  set_handover_step_offset(state, payload) {
    let handover_step = state.new_custom_work_package.handover_steps[payload.index];
    handover_step.offset = payload.offset;
    state.new_custom_work_package.handover_steps = [
      ...state.new_custom_work_package.handover_steps.slice(0, payload.index),
      handover_step,
      ...state.new_custom_work_package.handover_steps.slice(payload.index + 1)
    ];
  },
  set_design_step_offset(state, payload) {
    let design_step = state.new_custom_work_package.design_steps[payload.index];
    design_step.offset = payload.offset;
    state.new_custom_work_package.design_steps = [
      ...state.new_custom_work_package.design_steps.slice(0, payload.index),
      design_step,
      ...state.new_custom_work_package.design_steps.slice(payload.index + 1)
    ];
  },
  set_logistic_step_offset(state, payload) {
    let logistic_step = state.new_custom_work_package.logistic_steps[payload.index];
    logistic_step.offset = payload.offset;
    state.new_custom_work_package.logistic_steps = [
      ...state.new_custom_work_package.logistic_steps.slice(0, payload.index),
      logistic_step,
      ...state.new_custom_work_package.logistic_steps.slice(payload.index + 1)
    ];
  },
  set_work_packages(state, work_packages) {
    state.work_packages = [...work_packages];
  },
  set_work_packages_pagination(state, meta_data) {
    state.pagination = meta_data;
  },
  update_work_package(state, payload){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == payload.work_package_id;
    });
    let work_package = state.work_packages[index];
    state.work_packages = [
      ...state.work_packages.slice(0, index),
      Object.assign(work_package, payload.update),
      ...state.work_packages.slice(index + 1)
    ];
  },
  update_community_suggested(state, work_package_id){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == work_package_id;
    });
    let work_package = state.work_packages[index];
    work_package.is_community_suggested = true;
    state.work_packages = [
      ...state.work_packages.slice(0, index),
      work_package,
      ...state.work_packages.slice(index + 1)
    ];
  },
  update_wwork_step(state, payload){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == payload.work_package_id;
    });
    let work_package = state.work_packages[index];
    const ws_index = work_package.work_steps.findIndex(function(item) {
      return item.id == payload.wwork_step_id;
    });
    const work_step = work_package.work_steps[ws_index];
    work_package.work_steps.splice(ws_index, 1, Object.assign(work_step, payload.update));
  },
  update_wwork_step_push_position(state, payload){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == payload.work_package_id;
    });
    let work_package = state.work_packages[index];
    const new_ws_index = work_package.work_steps.findIndex(function(item) {
      return item.id == payload.update.work_step;
    });
    const old_ws_index = work_package.work_steps.findIndex(function(item) {
      return item.id == payload.wwork_step_id;
    });
    const moved_ws = work_package.work_steps.splice(old_ws_index, 1)[0];
    work_package.work_steps.splice(new_ws_index, 0, moved_ws);
  },
  delete_work_package(state, work_package_id){
    const index = state.work_packages.findIndex(function(item) {
      return item.id == work_package_id;
    });
    state.work_packages = [
      ...state.work_packages.slice(0, index),
      ...state.work_packages.slice(index + 1)
    ];
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
